export class ObjectRecorder<T> {
	private object: T | null = null;

	set(object: T): void {
		this.object = object;
	}

	get(): T | null {
		return this.object;
	}

	reset(): void {
		this.object = null;
	}
}
